import React, { useEffect, useRef } from "react";

import * as d3 from "d3";

import { AllocationAreaProps } from "../type";

const Area = (props: AllocationAreaProps) => {
  const { data = [], yScale, xScale, bands } = props;
  const areaRef = useRef<SVGGElement>(null);

  useEffect(() => {
    const generateArea = d3
      .area()
      .x(d => xScale(d["data"].date))
      .y0(d => yScale(d[0] || 0))
      .y1(d => yScale(d[1] || 0));

    d3.select(areaRef.current)
      .selectAll("path")
      .data([data])
      .join("path")
      .attr("d", generateArea)
      .attr("opacity", 0.8)
      .attr("fill", bands[data?.key || ""]);
  }, [data, xScale, yScale, bands]);

  return <g ref={areaRef} />;
};

export default Area;
